'use client';

import { useMemo } from 'react';
import { Box, BottomNavigation, BottomNavigationAction } from '@mui/material';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import { IconSvg, IconType } from '../Icon';
import { ROUTES } from '@/utils/constants';
const BottomTabNavigator = (): JSX.Element => {
  const navItems: {
    title: string;
    url: string;
    icon: IconType;
  }[] = [{
    title: 'خانه',
    url: ROUTES.root.href,
    icon: 'Home'
  }, {
    title: 'طرح‌ها',
    url: ROUTES.crowdfundingPlan.href,
    icon: 'Papers'
  }, {
    title: ROUTES.userCrowdfundingPlan.name,
    url: ROUTES.userCrowdfundingPlan.href,
    icon: 'Plan'
  }, {
    title: 'پروفایل من',
    url: ROUTES.dashboard.root.href,
    icon: 'Profile'
  }];
  const pathname = usePathname();
  const activeIndex = useMemo(() => {
    return pathname === '/' ? 0 : navItems.findIndex(menu => pathname === menu.url);
  }, [pathname]);
  return <Box sx={{
    right: 0,
    left: 0,
    bottom: 0,
    position: 'fixed',
    zIndex: 100,
    display: {
      md: 'none',
      xs: 'block'
    },
    '& .MuiBottomNavigation-root': {
      height: '70px',
      p: 'var(--spacing_xs)'
    }
  }} data-sentry-element="Box" data-sentry-component="BottomTabNavigator" data-sentry-source-file="BottomTabNavigator.tsx">
      <BottomNavigation showLabels data-sentry-element="BottomNavigation" data-sentry-source-file="BottomTabNavigator.tsx">
        {navItems.map((navItem, idx) => {
        return <BottomNavigationAction LinkComponent={Link} href={navItem.url} label={navItem.title} icon={<IconSvg component={navItem.icon} fill={idx === activeIndex ? 'rgba(37, 37, 37, 1)' : 'rgba(0, 0, 0, 0.4)'} width='37' height='36' />} key={'nav_item_m' + idx} sx={{
          typography: 'captionSmallStrong__Wallfund',
          color: idx === activeIndex ? 'rgba(37, 37, 37, 1)' : 'text.text2',
          p: 0
        }} />;
      })}
      </BottomNavigation>
    </Box>;
};
export default BottomTabNavigator;